import { BibleVerse, VerseCategory, Language } from "./types";
export interface ApiResponse<T> {
  data: T;
  status: "ok" | "error";
  error: { message: string; code: string };
  pagination: any;
  stream: any;
}
export interface BibleVerseInput {
  reference: string;
  // content: string;
  language: Language;
  category: VerseCategory;
  description: string;
  author: string;
  verse_text: string;
  notes: string;
}

export interface BibleVerseUpdateInput extends BibleVerseInput {
  id: number;
  isActive?: boolean;
}

export interface BibleVerseWithRelations extends BibleVerse {
  translations?: BibleVerse[];
}

export class BibleVersesApi {
  private baseUrl = "/api/bible-verses";

  async getAllVerses(): Promise<BibleVerse[]> {
    const token = localStorage.getItem("token");

    const response = await fetch(this.baseUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch bible verses");
    }
    const resp = (await response.json()) as any;
    return resp.data;
  }

  async getVersesByCategory(category: VerseCategory): Promise<BibleVerse[]> {
    const token = localStorage.getItem("token");
    const response = await fetch(`${this.baseUrl}/category/${category}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch verses by category");
    }
    return response.json();
  }

  async getVersesByLanguage(language: Language): Promise<BibleVerse[]> {
    const response = await fetch(`${this.baseUrl}/language/${language}`);
    if (!response.ok) {
      throw new Error("Failed to fetch verses by language");
    }
    return response.json();
  }

  async getVerseById(id: number): Promise<BibleVerse> {
    const response = await fetch(`${this.baseUrl}/${id}`);
    if (!response.ok) {
      throw new Error("Failed to fetch verse");
    }
    return response.json();
  }

  async createVerse(verse: BibleVerseInput): Promise<ApiResponse<BibleVerse>> {
    const token = localStorage.getItem("token");

    const response = await fetch(this.baseUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(verse),
    });
    if (!response.ok) {
      throw new Error("Failed to create verse");
    }
    return response.json();
  }

  async updateVerse(
    verse: BibleVerseUpdateInput
  ): Promise<ApiResponse<BibleVerse>> {
    const token = localStorage.getItem("token");

    const response = await fetch(`${this.baseUrl}/${verse.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(verse),
    });
    if (!response.ok) {
      throw new Error("Failed to update verse");
    }
    return response.json();
  }

  async deleteVerse(id: number): Promise<void> {
    const token = localStorage.getItem("token");
    const response = await fetch(`${this.baseUrl}/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error("Failed to delete verse");
    }
  }

  async toggleVerseStatus(id: number, isActive: boolean): Promise<BibleVerse> {
    const response = await fetch(`${this.baseUrl}/${id}/status`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ isActive }),
    });
    if (!response.ok) {
      throw new Error("Failed to toggle verse status");
    }
    return response.json();
  }
}

export const bibleVersesApi = new BibleVersesApi();
